module.exports = __webpack_public_path__ + "static/img/img_logo_7.7f1d9f2e.png";